<template>
  <q-btn
    ref="button"
    :label="isEmpty(column.filter) ? column.label : `${column.label}: ${getFilterValues}`"
    :class="[{
      'filter-button': true,
      'selected': !isEmpty(column.filter),
      'highlighted': highlightedButton === column.name
    }]"
    icon-right="keyboard_arrow_down"
    flat
    no-caps
  >
    <q-popover
      @show="inputText = column.filter; focusInput(column.name); highlightButton(column.name);"
      @hide="column.filter = inputText; search(column); releaseButton()"
      :offset="popperOffset"
      ref="popover"
      anchor="bottom left"
      self="top left"
    >
      <div>
        <q-input
          v-model="inputText"
          :before="[{icon: 'search'}]"
          :ref="`input-${column.name}`"
          @keyup.enter="column.filter = inputText; search(column)"
          hide-underline
        />
        <div style="padding: 10px; border-top: 1px solid #bbb;">
          <q-btn
            @click="column.filter = inputText; search(column)"
            color="primary"
            no-caps
            label="Применить"
          />
          <q-btn
            @click="inputText = ''"
            flat
            no-caps
            label="Очистить"
          />
        </div>
      </div>
    </q-popover>
  </q-btn>

</template>

<script>
  import {
    QBtn,
    QPopover,
    QInput,
    QDatetimePicker,
    QCheckbox,
    QSearch,
    QIcon,
    date
  } from 'quasar';

  import TableFilterBase from './TableFilterBase';

  export default {
    name: 'TableFilterText',
    components: {
      QBtn,
      QPopover,
      QInput,
      QDatetimePicker,
      QCheckbox,
      QSearch,
      QIcon
    },
    extends: TableFilterBase,
    props: {
      column: {
        type: Object,
        default: {}
      },
      columns: {
        type: Array,
        default: []
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "./style";
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TableFilter/TableFilterText.vue